import script from "./PlatformsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlatformsPage.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__